import React from 'react';
import { Link } from 'react-router-dom';
import './PublicFooter.css';

export default function PublicFooter() {
  return (
    <footer className="public-footer" dir="rtl">
      <div className="public-footer__inner">
        <nav className="public-footer__nav" aria-label="קישורי תחתית">
          <Link to="/contact" className="public-footer__link">צור קשר</Link>
          <Link to="/terms" className="public-footer__link">תנאי שירות</Link>
          <Link to="/privacy" className="public-footer__link">פרטיות משתמש</Link>
        </nav>
      </div>
    </footer>
  );
}